<template>
  <div class="meiyu">
    <div class="top">
      <div class="topdate">{{date}}</div>
      <span class="title">柯桥抗旱</span>
      <div class="full" @click="buttonfull">
        <svg v-if="watchfull" class="icon" aria-hidden="true" style="color: #00dcfc;">
          <use xlink:href="#iconsuoxiaoquanping" />
        </svg>
        <svg v-else class="icon" aria-hidden="true" style="color: #00dcfc;">
          <use xlink:href="#iconquanping" />
        </svg>
      </div>
      <div class="back" @click="back" v-show="backitem">
        <img src="@/assets/meiyu/back.png" alt />
        <span class="backdesc">返回</span>
      </div>
    </div>
    <div v-loading="loading" id="centermap" class="homepage-map"></div>
    <div class="left">
      <div class="realtimerain">
        <div class="contain">
          <div class="title">
            <div class="titlename">
              <div class="titlename_up">
                <span class="ssyq">天气预报</span>
              </div>
              <img src="@/assets/meiyu/titlebottom.png" alt />
            </div>
          </div>
          <div class="content">
            <div
              class="weather"
              v-loading="weatherloading"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.8)"
            >
              <div class="todayweather">
                <img :src="cond_code" alt />
                <span class="realtime">
                  <span class="ssd">
                    {{realtimetmp}}
                    <span class="danwei">℃</span>
                  </span>
                  {{cond_txt}}(实时)
                </span>
                <span class="jrqw">{{tmp_min}}-{{tmp_max}}℃</span>
                <span class="words" v-if="txt_d === txt_n">{{txt_d}}</span>
                <span class="words" v-else>{{txt_d}}转{{txt_n}}</span>
              </div>
              <div class="nextweather" v-for="(item,index) in nextweaarr" :key="index">
                <p v-if="index === 0">明天</p>
                <p v-else>{{weekday}}</p>
                <img :src="require('@/assets/weather/' + item.code_d + '.png')" alt />
                <span>{{item.tmp_min}}-{{item.tmp_max}}℃</span>
                <span class="words" v-if="item.txt_d === item.txt_n">{{item.txt_d}}</span>
                <span class="words" v-else>{{item.txt_d}}转{{item.txt_n}}</span>
              </div>
            </div>
            <div class="rzdyl">
              <img class="leftimg" style="cursor:pointer" src="@/assets/homepage_img/wjytsbg.png" alt  @click="choosetime()"/>
              <img class="rightimg" style="cursor:pointer" src="@/assets/homepage_img/mjylbg.png" alt  @click="choosetime()"/>
              <div class="leftdesc">
                <span class="words">无降雨天数</span>
                <span class="day">{{RainfallSituation.NoneRainfallCount}}</span>
                <span class="dw">天</span>
              </div>
              <div class="rightdesc">
                <span class="words">面降雨量&lt;10mm</span>
                <span class="day">{{RainfallSituation.SurfaceRainfallLess10}}</span>
                <span class="dw">天</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="realtimewater" ref="realtimewater">
        <div class="contain">
          <div class="title raintitle">
            <div class="titlename">
              <div class="titlename_up">
                <span class="sssq">实时水情</span>
                <div class="selected_time">
                  <span
                    class="time_item"
                    :class="{'item_active':index==choosed1}"
                    v-for="(item, index) in selectedReservoirRiver"
                    :key="index"
                    @click="checkItem1(item, index)"
                  >
                    <span>{{ item.name }}</span>
                  </span>
                </div>
              </div>
              <img src="@/assets/meiyu/titlebottom.png" alt />
            </div>
          </div>
          <div class="content">
            <el-table
              :data="tableData"
              v-if="this.tabName === '河道'"
              :max-height="tableheight"
              stripe
              style="width:100%;"
              :row-class-name="tableRowClassName"
            >
              <el-table-column prop="stnm" label="站点名称" :min-width="minwidth"></el-table-column>
              <el-table-column align="right" prop="water_Str" label="水位" min-width="45"></el-table-column>
              <el-table-column
                align="right"
                prop="overflowWarningWater_Str"
                label="超警戒"
                min-width="51"
              ></el-table-column>
              <el-table-column
                align="right"
                prop="overflowGuaranteeWater_Str"
                label="超保证"
                min-width="51"
              ></el-table-column>
              <el-table-column header-align="center" align="right" prop label="历史最低" min-width="63"></el-table-column>
            </el-table>
            <el-table
              :data="tableData"
              v-if="this.tabName === '水库'"
              :max-height="tableheight"
              stripe
              style="width:100%;"
              :row-class-name="tableRowClassName1"
            >
              <el-table-column prop="stnm" label="站点名称" :min-width="minwidth"></el-table-column>
              <el-table-column align="right" prop="water_Str" label="水位" min-width="45"></el-table-column>
              <el-table-column align="right" prop="warningWater_Str" label="汛限水位" min-width="51"></el-table-column>
              <el-table-column
                align="right"
                prop="overflowWarningWater_Str"
                label="超汛限"
                min-width="51"
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="sk">
        <div class="contain">
          <div class="title">
            <div class="titlename">
              <el-select
                class="titlename_select"
                v-model="reservoirName"
                placeholder="请选择"
                @change="selectedReservoir"
                popper-class="select-option"
              >
                <el-option
                  v-for="item in reservoirData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <img src="@/assets/meiyu/titlebottom.png" alt />
            </div>
          </div>
          <div class="echart_content">
            <waterLevel
              :sTID="sTID"
              :impoundmentRate="reservoirImpoundmentInfo.impoundmentRate"
              :deadWaterLevel="reservoirImpoundmentInfo.deadWaterLevel"
              :yMax="yMax"
              :yMin="yMin"
            ></waterLevel>
          </div>
          <div
            class="echart_down"
            v-loading="loadingReservoirImpoundmentInfo"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
          >
            <div>
              <div>比昨日减蓄</div>
              <div>
                <span>{{reservoirImpoundmentInfo.reduceImpoundment }}</span>
                <span class="echart_down_unit">万m³</span>
              </div>
            </div>
            <div>
              <div>最大可供水量</div>
              <div>
                <span>{{reservoirImpoundmentInfo.supplyWater}}</span>
                <span class="echart_down_unit">万m³</span>
              </div>
            </div>
            <div>
              <div>最大可供水天数</div>
              <div>
                <span>{{this.formatValue(reservoirImpoundmentInfo.supplyDays)}}</span>
                <span class="echart_down_unit">天</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="zz"
        ref="zz"
        v-loading="zzloading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <div class="contain">
          <div class="title">
            <div class="titlename">
              <span class="titlename_span">重点闸站实时工况</span>
              <img src="@/assets/meiyu/titlebottom.png" alt />
              <span @click="dialogFormVisible = true" class="more">更多</span>
            </div>
          </div>
          <div class="content">
            <div class="gateitem" v-for="(item,index) in gates" :key="index">
              <div class="gatetop">
                <span class="name">{{item.gcName}}</span>
                <span class="desc">{{item.state}}-{{item.operateType}}</span>
                <span class="time">{{item.lastOperatTime.slice(0, 10)}}</span>
              </div>
              <div class="gateicons">
                <div
                  class="gateicon"
                  v-for="(item,index) in item.getes"
                  :key="index"
                  style="display:inline-block"
                >
                  <img v-if="item.gateOn === 0" src="@/assets/meiyu/zha2.png" alt />
                  <img v-else src="@/assets/meiyu/banzha.png" alt />
                  <span>{{index + 1}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog id="zhazhan" title="闸站运行情况" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <div class="gateitem" v-for="(item,index) in moregate" :key="index">
        <div class="gatetop">
          <span class="name">{{item.gcName}}</span>
          <span class="desc">{{item.state}}-{{item.operateType}}</span>
          <span class="time">{{item.lastOperatTime}}</span>
        </div>
        <div class="gateicons">
          <div
            class="gateicon"
            v-for="(item,index) in item.getes"
            :key="index"
            style="display:inline-block"
          >
            <img v-if="item.gateOn === 0" src="@/assets/meiyu/zha2.png" alt />
            <img v-else src="@/assets/meiyu/banzha.png" alt />
            <span>{{index + 1}}</span>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="单站雨量统计" :visible.sync="dialogStation" id="danzhan" :close-on-click-modal="false">
      <div class="title">
        <div class="titlename">
          <div class="titlename_up">
            <div class="selected_time">
              <span
                class="time_item"
                :class="{'item_active':index==choosed3}"
                v-for="(item, index) in selectedTime"
                :key="index"
                @click="checkItem3(item, index)"
              >
                <span>{{ item.name }}</span>
              </span>
            </div>
          </div>
          <img src="@/assets/meiyu/titlebottom.png" alt />
        </div>
      </div>
      <div class="topthree">
        <div class="topitem" v-for="(item,index) in alldz" :key="index">
          <img v-if="item.rain >= 50" src="@/assets/meiyu/redbox.png" alt />
          <img v-else src="@/assets/meiyu/bluebox.png" alt />
          <span class="topdesc">{{item.stnm}}</span>
          <span class="val">
            {{item.rain}}
            <span class="danwei">mm</span>
          </span>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="时间选择" :visible.sync="choose" id="choset" :close-on-click-modal="false">
      <div class="title">
        <div class="titlename">
          <div class="titlename_up">
            <div class="selected_time" style="margin-left:30px;">
              <el-date-picker
              v-model="datev"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              >
            </el-date-picker>
            </div>
          </div>
        </div>
        <div style="width:100%;text-align:center;margin-top:30px;">
        <span slot="footer" class="dialog-footer">
        <el-button @click="choose = false">取 消</el-button>
        <el-button type="primary" @click="choose = false,getRainfallSituation()"
          >确 定</el-button>
      </span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as L from 'leaflet'
import screenfull from 'screenfull'
import monitorTypes from '@/store/types/monitor'
import meiyuTypes from '@/store/types/meiyu'
import waterLevel from '@/views/drought/waterLevel'
import homepageTypes from '@/store/types/homepage'
import request from '@/utils/request'
import config from '@/config'
require('@/assets/map/leaflet.ChineseTmsProviders.js')
var echarts = require('echarts')
export default {
  components: {
    waterLevel
  },
  data () {
    return {
      weatherloading: true,
      backitem: true,
      zzloading: true,
      watchfull: '',
      choset: false,
      isFullscreen: false,
      myChartHeight: '',
      dialogFormVisible: false,
      datev: '',
      choose: false,
      allrain: '',
      watername: '',
      wateroverflow: '',
      aDDVCD: '330324',
      documentwidth: document.documentElement.clientWidth,
      meiyurain: [],
      tops: [],
      alldz: [],
      reservoirData: [
        {
          value: 'echartOne',
          label: '平水江水库',
          sTID: '214',
          yMax: 50,
          yMin: 30
        },
        {
          value: 'echartTwo',
          label: '大雷岙水库',
          sTID: '253',
          yMax: 128,
          yMin: 110
        },
        {
          value: 'echartThree',
          label: '解放水库',
          sTID: '218',
          yMax: 24,
          yMin: 10
        },
        {
          value: 'echartFour',
          label: '大岙水库',
          sTID: '232',
          yMax: 162,
          yMin: 140
        }
      ],
      reservoirName: '平水江水库',
      sTID: '214',
      yMax: '50',
      yMin: '30',
      reservoirImpoundmentInfo: { deadWaterLevel: '' },
      loadingReservoirImpoundmentInfo: false,
      loading: true,
      loading1: true,
      loadingd: true,
      date: '',
      height: document.documentElement.clientHeight + 'px',
      tableheight: 10,
      superpolice: [],
      gates: [],
      tableData: [],
      selectedTime: [
        {
          name: '当日',
          value: '24h'
        },
        {
          name: '前3小时',
          value: '3h'
        },
        {
          name: '前1小时',
          value: '1h'
        }
      ],
      selectedReservoirRiver: [
        {
          name: '水库',
          value: 'reservoir'
        },
        {
          name: '河道',
          value: 'river'
        }
      ],
      choosed: 2,
      choosed2: 2,
      choosed3: 2,
      chooseItem: '',
      chartnameAll: [],
      topsixvalueAll: [],
      choosed1: 1,
      gataData: [],
      minwidth: '75',
      moregate: [],
      yj: [],
      sID: '22',
      stationType: '2',
      waterFactor: '',
      rivercoordinate: [],
      map: '',
      dialogVisible: false,
      dialogStation: false,
      therainchart: false,
      BeginTime: '2019-06-01',
      tabName: '河道',
      realtimetmp: '',
      cond_txt: '',
      cond_code: '',
      tmp_min: '',
      tmp_max: '',
      txt_d: '',
      txt_n: '',
      nextweaarr: [
        // { date: '明天', cond_code: require('@/assets/weather/101.png'), tmp_min: '12', tmp_max: '25', txt_d: '多云', txt_n: '晴' },
        // { date: '星期四', cond_code: require('@/assets/weather/101.png'), tmp_min: '12', tmp_max: '25', txt_d: '多云', txt_n: '晴' }
      ],
      weekday: '',
      RainfallSituation: {}
    }
  },
  methods: {
    weatherdetail () {
      this.$axios
        .get('http://api.dayuteam.cn/weather/api/getWeather?code=CN101210506')
        .then(res => {
          // 当天天气
          this.realtimetmp = res.data.tmp
          this.cond_txt = res.data.cond_txt
          this.cond_code = require('@/assets/weather/' +
            res.data.cond_code +
            '.png')
          this.tmp_min = res.data.forecastDays[0].tmp_min
          this.tmp_max = res.data.forecastDays[0].tmp_max
          this.txt_d = res.data.forecastDays[0].txt_d
          this.txt_n = res.data.forecastDays[0].txt_n
          // 明后天天气
          // let arr = res.data.forecastDays.slice(1, 3)
          this.nextweaarr = res.data.forecastDays.slice(1, 3)
          console.log(res.data, 99999)
          let week = this.nextweaarr[1].id.date_forecast
          var weekDay = [
            '星期天',
            '星期一',
            '星期二',
            '星期三',
            '星期四',
            '星期五',
            '星期六'
          ]
          var myDate = new Date(Date.parse(week))
          this.weekday = weekDay[myDate.getDay()]
          this.weatherloading = false
        })
    },
    choosetime () {
      this.choose = true
    },
    buttonfull () {
      if (!screenfull.enabled) {
        return false
      } else {
        screenfull.toggle()
      }
    },
    // 获取水库水位
    getHourlyRiverLevelData () {
      this.$store
        .dispatch(homepageTypes.GET_LATEST_WATER_LEVEL, {
          sID: this.sID,
          sTID: this.sTID,
          stationType: this.stationType,
          waterFactor: this.waterFactor
        })
        .then(data => {
          this.echartData = data.rows[0]
        })
    },
    selectedReservoir (val) {
      this.reservoirData.forEach(item => {
        if (val === item.value) {
          this.reservoirName = item.label
          this.sTID = item.sTID
          this.yMax = item.yMax
          this.yMin = item.yMin
          this.getReservoirImpoundmentInfo()
          this.getHourlyRiverLevelData()
        }
      })
    },
    back () {
      this.isFullscreen = true
      this.$nextTick(() => {
        this.$router.go(-1)
      })
    },
    drawChart (chartname, topsixvalue) {
      let myChart = this.$echarts.init(document.getElementById('rainchart'))
      myChart.clear()
      myChart.setOption({
        title: {
          top: 5,
          text: '乡镇面雨量Top5',
          textStyle: {
            // 文字颜色
            color: '#fff',
            // 字体风格,'normal','italic','oblique'
            fontStyle: 'normal',
            // 字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            fontWeight: 'bold',
            // 字体系列
            fontFamily: 'sans-serif',
            // 字体大小
            fontSize: 13
          }
        },
        grid: {
          left: '-4%',
          right: '0%',
          bottom: '5%',
          top: '30%',
          containLabel: true
        },
        tooltip: {},
        xAxis: [
          {
            type: 'category',
            data: chartname,
            axisTick: {
              // alignWithLabel: true,
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              interval: 0,
              // rotate: 15,
              // 强制文字产生间隔
              textStyle: {
                // 文字样式
                color: '#fff',
                fontSize: 12,
                fontFamily: 'Microsoft YaHei'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#02cae5'
              }
            },
            axisLabel: {
              formatter: function () {
                return ''
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#fff'
              }
            }
          }
        ],
        series: [
          {
            name: '雨量',
            type: 'bar',
            barWidth: '40%',
            data: topsixvalue,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  1,
                  0,
                  0,
                  [
                    {
                      offset: 0,
                      color: '#00a2ff' // 0% 处的颜色
                    },
                    {
                      offset: 0.5,
                      color: '#01bbef' // 60% 处的颜色
                    },
                    {
                      offset: 1,
                      color: '#02cae5' // 100% 处的颜色
                    }
                  ],
                  false
                ),
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    // 数值样式
                    color: '#02cae5',
                    fontSize: 16
                  }
                }
              }
            }
          }
        ]
      })
    },
    drawChartAll (chartnameAll, topsixvalueAll) {
      let rainchartAll = this.$refs.rainchartAll
      let myChart = this.$echarts.init(rainchartAll)
      myChart.clear()
      myChart.setOption({
        title: {
          top: 5,
          textStyle: {
            // 文字颜色
            color: '#fff',
            // 字体风格,'normal','italic','oblique'
            fontStyle: 'normal',
            // 字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            fontWeight: 'bold',
            // 字体系列
            fontFamily: 'sans-serif',
            // 字体大小
            fontSize: 13
          }
        },
        grid: {
          left: '0%',
          right: '0%',
          bottom: '5%',
          top: '30%',
          containLabel: true
        },
        tooltip: {},
        xAxis: [
          {
            type: 'category',
            data: chartnameAll,
            axisTick: {
              // alignWithLabel: true,
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              interval: 0,
              // rotate: 15,
              // 强制文字产生间隔
              textStyle: {
                // 文字样式
                color: '#fff',
                fontSize: 12,
                fontFamily: 'Microsoft YaHei'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#02cae5'
              }
            },
            axisLabel: {
              formatter: function () {
                return ''
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#fff'
              }
            }
          }
        ],
        series: [
          {
            name: '雨量',
            type: 'bar',
            barWidth: '40%',
            data: topsixvalueAll,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  1,
                  0,
                  0,
                  [
                    {
                      offset: 0,
                      color: '#00a2ff' // 0% 处的颜色
                    },
                    {
                      offset: 0.5,
                      color: '#01bbef' // 60% 处的颜色
                    },
                    {
                      offset: 1,
                      color: '#02cae5' // 100% 处的颜色
                    }
                  ],
                  false
                ),
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    // 数值样式
                    color: '#02cae5',
                    fontSize: 16
                  }
                }
              }
            }
          }
        ]
      })
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.overflowWarningWater > 0 && row.overflowGuaranteeWater <= 0) {
        // 超警戒未超保证
        return 'warning-row'
      } else if (row.overflowGuaranteeWater > 0) {
        return 'success-row'
      }
      return ''
    },
    tableRowClassName1 ({ row, rowIndex }) {
      if (row.overflowWarningWater > 0) {
        // 超汛限
        return 'success-row'
      }
      return ''
    },
    getnowtime () {
      let thedate = new Date()
      let year = thedate.getFullYear()
      let month = thedate.getMonth() + 1
      let date = thedate.getDate()
      let hours = thedate.getHours()
      let minutes = thedate.getMinutes()
      let seconds = thedate.getSeconds()
      let weekend = thedate.getDay()
      switch (weekend) {
        case 1:
          weekend = '星期一'
          break
        case 2:
          weekend = '星期二'
          break
        case 3:
          weekend = '星期三'
          break
        case 4:
          weekend = '星期四'
          break
        case 5:
          weekend = '星期五'
          break
        case 6:
          weekend = '星期六'
          break
        case 0:
          weekend = '星期日'
          break
      }
      this.date =
        year +
        '年' +
        this.conver(month) +
        '月' +
        this.conver(date) +
        '日' +
        ' ' +
        weekend +
        ' ' +
        this.conver(hours) +
        ':' +
        this.conver(minutes) +
        ':' +
        this.conver(seconds)
    },
    conver (s) {
      return s < 10 ? '0' + s : s
    },
    leaflet (arr) {
      var imgm = L.tileLayer.chinaProvider('TianDiTu.Satellite.Map', {
        maxZoom: 18,
        minZoom: 10
      })
      var imga = L.tileLayer.chinaProvider('TianDiTu.Satellite.Annotion', {
        maxZoom: 18,
        minZoom: 10
      })
      var image = L.layerGroup([imgm, imga])
      let map = ''
      if (this.documentwidth <= 1400) {
        map = L.map('centermap', {
          center: [29.991, 120.569],
          zoom: 10,
          layers: [image],
          zoomControl: false
        })
      } else {
        map = L.map('centermap', {
          center: [29.991, 120.569],
          zoom: 11,
          layers: [image],
          zoomControl: false
        })
      }
      var myStyle = {
        color: '#2dd9f8',
        weight: 3,
        opacity: 1
      }
      request.get('https://' + window.location.host + '/yjjson/yongjiaTown.json').then(res => {
        L.geoJSON(res.data, {
          style: myStyle
        }).addTo(map)
        this.drawBoundary(res.data.features[0].geometry.coordinates, map)
      })
      this.map = map
    },
    drawBoundary (blist, map) {
      // 画遮蔽层的相关方法
      // 思路: 首先在中国地图最外画一圈，圈住理论上所有的中国领土，然后再将每个闭合区域合并进来，并全部连到西北角。
      // 这样就做出了一个经过多次西北角的闭合多边形
      // 定义中国东南西北端点，作为第一层
      var pNW = { lat: 59.0, lng: 73.0 }
      var pNE = { lat: 59.0, lng: 136.0 }
      var pSE = { lat: 3.0, lng: 136.0 }
      var pSW = { lat: 3.0, lng: 73.0 }
      // 向数组中添加一次闭合多边形，并将西北角再加一次作为之后画闭合区域的起点
      var pArray = []
      pArray.push(pNW)
      pArray.push(pSW)
      pArray.push(pSE)
      pArray.push(pNE)
      pArray.push(pNW)
      // 循环添加各闭合区域
      for (var i = 0; i < blist.length; i++) {
        var points = []
        blist[i].forEach(item => {
          points.push({ lat: item[1], lng: item[0] })
        })
        // $.each(blist[i],function(k,v){
        //     points.push({lat:v[1],lng:v[0]})
        // })
        // 将闭合区域加到遮蔽层上，每次添加完后要再加一次西北角作为下次添加的起点和最后一次的终点
        pArray = pArray.concat(points)
        pArray.push(pArray[0])
      }
      // 添加遮蔽层
      var plyall = L.polygon(pArray, {
        color: 'transparent',
        fillColor: '#242422',
        fillOpacity: 0.8
      }) // 建立多边形覆盖物
      plyall.addTo(map)
    },
    // 公共雨情信息接口调用
    commonRaininfo (type, item) {
      this.$store
        .dispatch(meiyuTypes.GET_TOWN_RAIN, {
          aDDVCD: this.aDDVCD,
          type: item.value,
          townOrderField: 'Rain',
          stationOrderField: ''
        })
        .then(data => {
          let detailarr = data.townData
          let chartnameAll = []
          let topsixvalueAll = []
          detailarr.forEach(item => {
            chartnameAll.push(item.addvcd)
            topsixvalueAll.push(item.rain)
          })
          if (type === 'qqmyl') {
            this.drawChartAll(chartnameAll, topsixvalueAll)
          } else {
            this.chartnameAll = chartnameAll
            this.topsixvalueAll = topsixvalueAll
          }
          this.alldz = data.stationData
          this.loading = false
        })
    },
    // 实时水情点击切换
    checkItem1 (item, index) {
      this.choosed1 = index
      if (this.choosed1 === 0) {
        this.reservoirwater()
      } else {
        this.riverwater()
      }
    },
    // 河道水情
    riverwater () {
      this.minwidth = '87'
      this.tabName = '河道'
      this.watername = '超保证'
      this.wateroverflow = 'overflowWarningWater'
      this.$store
        .dispatch(monitorTypes.GET_STATISTICS_RIVER_WATER, {
          aDDVCD: this.aDDVCD,
          stationName: '',
          orderField: this.wateroverflow,
          desc: true
        })
        .then(data => {
          this.tableData = data.rows
          this.loading = false
        })
    },
    // 水库水情
    reservoirwater () {
      this.minwidth = '75'
      this.tabName = '水库'
      this.watername = '超汛限'
      this.wateroverflow = 'overflowWarningWater'
      this.$store
        .dispatch(monitorTypes.GET_STATISTICS_RESERVOIR_WATER, {
          aDDVCD: this.aDDVCD,
          stationName: this.stationName,
          orderField: this.wateroverflow,
          desc: true
        })
        .then(data => {
          this.tableData = data.rows
          this.loading = false
        })
    },
    // 获取重点闸站实时工况
    geGgateData () {
      this.$store.dispatch(meiyuTypes.GET_PROJECT_GATES).then(data => {
        let gataData = data.results
        this.gates = gataData.slice(0, 3)
        this.moregate = gataData
        this.moregate.forEach(item => {
          if (item.lastOperatTime === undefined) {
            return ''
          } else {
            item.lastOperatTime = item.lastOperatTime.slice(0, 10)
          }
        })
        this.zzloading = false
      })
    },
    seasonRainfall () {
      this.loadingd = true
      this.$store
        .dispatch(meiyuTypes.GET_RAINLY_SEASON_RAINFALL, {
          aDDVCD: this.aDDVCD,
          beginTime: this.BeginTime
        })
        .then(data => {
          this.meiyurain.push({ name: '梅雨期面雨量', value: data.data.rain })
          this.meiyurain.push({
            name: '常年同期',
            value: data.data.lastYearRian
          })
          this.meiyurain.push({ name: '同比', value: data.data.accRate })
          this.loadingd = false
        })
    },
    getReservoirImpoundmentInfo () {
      this.loadingReservoirImpoundmentInfo = true
      this.$store
        .dispatch(homepageTypes.GET_RESERVOIR_IMPOUNDMENT_INFO, {
          stid: this.sTID
        })
        .then(data => {
          this.reservoirImpoundmentInfo = data
          this.loadingReservoirImpoundmentInfo = false
        })
    },
    formatValue (val) {
      if (val !== undefined && val !== '') {
        let newVal = parseFloat(val)
        if (newVal > 0) {
          return val
        }
      }
      return '--'
    },
    getRainfallSituation () {
      var pastYear = new Date()
      pastYear.setDate(pastYear.getDate() - 365)
      let date = new Date()
      let year = date.getFullYear()
      let begtime = year + '-' + '01-01'
      if (this.datev === '') {
        // this.datev = this.getNowFormatDate(pastYear)
        this.datev = begtime
      }

      this.$axios.get(config.ApiYJ + '/HydrologyCenter/rainfall_situation', {
        params: {
          sID: 22,
          BeginTime: this.datev,
          EndTime: this.getNowFormatDate(new Date())
        }
      }).then(data => {
        var res = data.data
        this.RainfallSituation.NoneRainfallCount = res.noneRainfallCount
        this.RainfallSituation.SurfaceRainfallLess10 = res.surfaceRainfallLess10
      })
    }
  },
  created () {
    this.getReservoirImpoundmentInfo()
    this.getRainfallSituation()
  },
  mounted () {
    this.weatherdetail()
    window.onresize = () => {
      this.watchfull = screenfull.isFullscreen
      if (this.watchfull) {
        this.backitem = false
      } else {
        this.backitem = true
      }
    }
    this.geGgateData()
    let _this = this // 声明一个变量指向Vue实例this，保证作用域一致
    this.timer = setInterval(() => {
      _this.getnowtime()
    }, 1000)
    this.$nextTick(() => {
      this.leaflet()
    })
    this.getnowtime()
    this.riverwater()
    this.seasonRainfall()
    this.loading = false
    this.getHourlyRiverLevelData()
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('raintitle')
      let rainDiv = document.getElementsByClassName('realtimewater')
      this.tableheight =
        rainDiv[0].offsetHeight - contentDiv[0].offsetHeight - 30
    })
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer) // 在Vue实例销毁前，清除我们的定时器
    }
  }
}
</script>
<style>
.select-option {
  z-index: 9999 !important;
  border: 1px solid #00f0ff;
  background-color: #060a22;
}
.select-option .el-select-dropdown__item {
  background-color: #060a22;
  color: #ffffff;
}
.select-option .el-select-dropdown__item.hover,
.select-option .el-select-dropdown__item:hover {
  background-color: #10173e;
}
</style>

<style lang="less" scoped>
@import url("../../assets/map/leaflet.css");
.centerMapContent {
  width: 100%;
  height: 1080px;
  position: relative;
}
#centermap {
  width: 100%;
  height: 1080px;
  position: relative;
}
@media screen and (min-height: 1100px) {
  .centerMapContent {
    width: 100%;
    height: 100%;
    position: relative;
  }
  #centermap {
    width: 100%;
    height: 100%;
    position: relative;
  }
}
.mapboxgl-control-container {
  display: none;
}
.el-row {
  margin-bottom: 20px;
}
.el-row:last-child {
  margin-bottom: 0;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  /* background:rgba(162,44,25,.6); */
  background-image: url(~@/assets/meiyu/chaojin.png);
  background-repeat: no-repeat;
  background-size: 141px 87px;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  /* min-height: 36px; */
  height: 87px;
  /* height: 100%; */
}
#chartall,
#danzhan,
#zhazhan {
  z-index: 9999999 !important;
}
.rainchartAll {
  width: 1000px;
  height: 280px;
  margin: 50px auto 0 auto;
}
.row-bg {
  padding: 10px 0;
  position: absolute;
  width: 850px;
  height: 85px;
  left: 50%;
  margin-left: -425px;
  top: 85px;
  z-index: 9999;
}
.warn-name {
  width: 100%;
  height: 20px;
  font-size: 16px;
  text-align: center;
  color: #fff;
  margin: 0;
  padding: 15px 0;
}
.warn-num {
  width: 100%;
  height: 20px;
  text-align: center;
  color: #ffff00;
  font-size: 30px;
  margin: 0;
  padding: 5px 0;
  font-style: italic;
  font-weight: 900;
}
.warn-num > span {
  font-size: 16px;
  color: #fff;
  margin-left: 10px;
}
</style>
<style lang="less" scoped>
.meiyu {
  // background: #21251f;
  height: 100%;
  position: relative;
  .el-dialog {
    .topthree {
      // display: inline-block;
      height: 70px;
      // justify-content: space-between;
      // display: flex;
      .topitem {
        // margin-top: 25px;
        position: relative;
        display: inline-block;
        color: #fff;
        width: 117px;
        margin-left: 45px;
        margin-top: 25px;
        img {
          width: 117px;
          height: 71px;
        }
        .topdesc {
          font-size: 14px;
          position: absolute;
          top: 11px;
          left: 25px;
          width: 100px;
          left: 50%;
          margin-left: -50px;
          height: 15px;
          text-align: center;
        }
        .val {
          .topdesc;
          top: 35px;
          left: 45px;
          font-size: 24px;
          text-align: center;
          font-style: italic;
          font-weight: 500;
          .danwei {
            font-size: 14px;
            position: absolute;
            top: 10px;
          }
        }
      }
    }
    .title {
      height: 33px;
      position: relative;
      margin-top: -8px;
      .titlename {
        height: 33px;
        position: relative;
        /deep/ .titlename_select {
          position: absolute;
          top: -13px;
          .el-input--suffix {
            .el-input__inner {
              width: 160px;
              background: #060a22;
              border: none;
              color: #ffffff;
              font-size: 18px;
            }
          }
        }
        .button {
          position: relative;
          display: inline-block;
          padding: 0.5rem 1rem;
          background: transparent;
          color: white;
          text-transform: uppercase;
          text-decoration: none;
          font: bold 200%/1 sans-serif;
          &::before {
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 0;
            background: #fff;
            transform: skew(45deg);
          }
        }
        .titlename_span {
          font-size: 18px;
          color: #fff;
          position: absolute;
          top: 0;
        }
        .titlename_up {
          width: 100%;
          height: 100%;
          span.ssyq,
          span.sssq {
            width: 20%;
            font-size: 18px;
            display: block;
            float: left;
            color: #fff;
          }
          .selected_time {
            width: 80%;
            height: 100%;
            float: right;
            .time_item {
              cursor: pointer;
              height: 30px;
              float: right;
              padding: 0 7px;
              line-height: 26px;
              display: block;
              font-size: 14px;
              color: #ffffff;
              border: 1px solid #079eb6;
              transform: skewX(-30deg);
              span {
                display: block;
                transform: skewX(30deg);
              }
            }
            .item_active {
              background: #064961;
            }
          }
        }
        img {
          width: 100%;
          height: 7px;
          position: absolute;
          top: 27px;
        }
      }
    }
  }
  .top {
    background-image: url("~@/assets/meiyu/top.png");
    background-repeat: no-repeat;
    background-size: 100% 200%;
    height: 77px;
    width: 100%;
    text-align: center;
    position: absolute;
    z-index: 99999;
    .topdate {
      color: #fefefe;
      font-size: 15px;
      position: absolute;
      top: 15px;
      left: 65px;
    }
    .title {
      margin-top: 23px;
      font-size: 32px;
      color: #00f0ff;
      font-weight: bold;
      display: inline-block;
    }
    .person {
      color: #fefefe;
      font-size: 15px;
      position: absolute;
      top: 15px;
      right: 90px;
      .dbld {
        span {
          color: #fec307;
        }
      }
      .zbry {
        .dbld;
        margin-left: 30px;
      }
    }
    .back {
      position: absolute;
      cursor: pointer;
      right: 15px;
      top: 8px;
      width: 70px;
      img {
        width: 26px;
        height: 24px;
      }
      .backdesc {
        color: #00dcfc;
        font-size: 15px;
        line-height: 15px;
        display: inline-block;
        vertical-align: middle;
        margin-top: -8px;
        margin-left: 5px;
      }
    }
    .full {
      .back;
      right: 75px;
    }
  }
  .left {
    width: 430px;
    height: 850px;
    position: absolute;
    // background: #fec307;
    top: 75px;
    bottom: 40px;
    left: 50px;
    z-index: 9999;
    .warning {
      width: 430px;
      height: 85px;
      line-height: 85px;
      text-align: center;
      background-image: url("~@/assets/meiyu/warningbox.png");
      background-repeat: no-repeat;
      background-size: 110% 200%;
      background-position: -14px -43px;
      img {
        margin-left: 30px;
        width: 147px;
        height: 23px;
      }
      span {
        margin-left: 20px;
        font-size: 18px;
        color: #fff;
        // margin-top: -5px;
        float: right;
        margin-right: 55px;
      }
    }
    .realtimerain {
      width: 100%;
      height: 350px;
      margin-top: 10px;
      background: #060a22;
      // box-shadow: 0 0 5px #283955 inset;
      box-shadow: 0 0 12px #253578;
      padding: 15px 27px;
      .contain {
        width: 380px;
        height: 390px;
        // background: #fec307;
        .title {
          height: 33px;
          .titlename {
            height: 33px;
            position: relative;
            /deep/ .titlename_select {
              position: absolute;
              top: -13px;
              .el-input--suffix {
                .el-input__inner {
                  width: 160px;
                  background: #060a22;
                  border: none;
                  color: #ffffff;
                  font-size: 18px;
                }
              }
            }
            .button {
              position: relative;
              display: inline-block;
              padding: 0.5rem 1rem;
              background: transparent;
              color: white;
              text-transform: uppercase;
              text-decoration: none;
              font: bold 200%/1 sans-serif;
              &::before {
                content: "";
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                z-index: 0;
                background: #fff;
                transform: skew(45deg);
              }
            }
            .titlename_span {
              font-size: 18px;
              color: #fff;
              position: absolute;
              top: 0;
            }
            .titlename_up {
              width: 100%;
              height: 100%;
              span.ssyq,
              span.sssq {
                width: 20%;
                font-size: 18px;
                display: block;
                float: left;
                color: #fff;
              }
              .selected_time {
                width: 80%;
                height: 100%;
                float: right;
                .time_item {
                  cursor: pointer;
                  height: 30px;
                  float: right;
                  padding: 0 7px;
                  line-height: 26px;
                  display: block;
                  font-size: 14px;
                  color: #ffffff;
                  border: 1px solid #079eb6;
                  transform: skewX(-30deg);
                  span {
                    display: block;
                    transform: skewX(30deg);
                  }
                }
                .item_active {
                  background: #064961;
                }
              }
            }
            img {
              width: 380px;
              height: 7px;
              position: absolute;
              top: 27px;
            }
          }
        }
        .content {
          margin-top: 10px;
          // width: 430px;
          .weather {
            height: 176px;
            // width: 430px;
            // background: #00deff;
            .todayweather {
              width: 135px;
              height: 176px;
              // background: #00deff;
              // display: inline-block;
              float: left;
              text-align: center;
              img {
                width: 60px;
                // margin-top: 30px;
                // margin-bottom: 5px;
              }
              span {
                margin-top: 8px;
                display: block;
                font-size: 16px;
                color: #fff;
              }
              .ssd {
                font-size: 28px;
                display: inline-block;
                margin-right: 7px;
                .danwei {
                  display: inline-block;
                  font-size: 14px;
                }
              }
            }
            .nextweather {
              width: 110px;
              height: 176px;
              background-color: #0a1f46;
              display: inline-block;
              margin-left: 10px;
              text-align: center;
              color: #fff;
              font-size: 15px;
              p {
                font-size: 15px;
              }
              img {
                width: 50px;
                margin-top: 10px;
                margin-bottom: 10px;
              }
              span {
                display: block;
                margin-top: 3px;
              }
            }
          }
          .rzdyl {
            height: 75px;
            margin-top: 25px;
            color: #fff;
            img {
              width: 180px;
              height: 72px;
              position: absolute;
            }
            .rightimg {
              right: 30px;
            }
            .leftdesc {
              width: 180px;
              height: 72px;
              text-align: center;
              display: inline-block;
              margin-top: 11px;
              cursor: pointer;
              .words {
                font-size: 16px;
                // margin-left: 77px;
                // line-height: 72px;
                display: block;
                // position: relative;
              }
              .day {
                font-size: 24px;
                font-style: italic;
              }
              .dw {
                font-size: 14px;
                margin-left: 3px;
              }
            }
            .rightdesc {
              .leftdesc;
              margin-left: 13px;
            }
            .yl {
              font-size: 28px;
              color: #00f0ff;
              margin-left: 15px;
              .danwei {
                font-size: 16px;
              }
            }
            .xs {
              margin-left: 15px;
              color: #fff;
              font-size: 16px;
            }
          }
        }
      }
    }
    .realtimewater {
      .realtimerain;
      margin-top: 10px;
      height: 600px;
      padding: 15px 0;
      .contain {
        height: 290px;
        width: 405px;
        .title {
          margin-left: 27px;
        }
        .content {
          margin-top: 10px;
          width: 430px;
        }
      }
    }
  }
  .right {
    width: 430px;
    height: 800px;
    position: absolute;
    // background: #fec307;
    top: 75px;
    bottom: 40px;
    right: 50px;
    z-index: 9999;
    .sk {
      .left>.realtimerain;
      height: 430px;
      .echart_content {
        width: 380px;
        height: 280px;
        margin-top: 10px;
        padding-top: 30px;
        position: relative;
        overflow: hidden;
      }
      .echart_down {
        width: 380px;
        height: 70px;
        margin-top: 15px;
        padding: 10px;
        border-top: 1px solid #2dd9f8;
        display: flex;
        flex-flow: row;
        justify-content: center;
        & > div {
          font-size: 12px;
          width: 400px;
          height: 50px;
          color: rgb(255, 255, 255);
          border-right: 1px solid rgb(22, 29, 55);
          text-align: center;
          font-size: 15px;
          & > div:nth-child(2) {
            font-weight: bold;
            font-style: italic;
            color: rgb(0, 222, 255);
            span {
              font-size: 20px;
            }
            .echart_down_unit {
              font-size: 14px;
            }
          }
          & > div {
            margin-top: 8px;
          }
        }
        & > div:last-child {
          border-right: none;
        }
      }
    }
    .zz {
      .left>.realtimerain;
      height: 520px;
      .more {
        float: right;
        font-size: 15px;
        color: #00deff;
        cursor: pointer;
      }
      .content {
        .gateitem {
          margin-top: 17px;
          width: 380px;
          // height: 100px;
          border: 1px solid #1a3a6c;
          .gatetop {
            height: 35px;
            line-height: 35px;
            background: #0f3164;
            .name {
              font-size: 15px;
              color: #fff;
              float: left;
              margin-left: 17px;
            }
            .time {
              color: #fff;
              font-size: 14px;
              float: right;
              margin-right: 10px;
            }
            .desc {
              font-size: 14px;
              color: #00deff;
              float: right;
              margin-right: 17px;
            }
          }
          .gateicons {
            margin-top: 6px;
            .gateicon {
              margin-left: 17px;
              height: 55px;
              position: relative;
              margin-top: 5px;
              // margin-bottom: 5px;
              text-align: center;
              width: 22px;
              height: 38px;
              img {
                width: 22px;
                height: 38px;
              }
              span {
                color: #fff;
                font-size: 14px;
                display: block;
              }
            }
          }
        }
      }
    }
  }
}
.meiyu /deep/ .el-dialog {
  z-index: 9999999;
  background-color: #060a22;
  margin-top: 22vh !important;
  width: 47%;
  // height: 50%
  .el-dialog__body {
    padding-top: 10px;
    overflow: auto;
    height: 400px;
  }
  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__close {
    color: #fff;
  }
}
.meiyu /deep/ #choset .el-dialog {
  width: 500px;
  height: 200px;
}
.el-dialog {
  background-color: #060a22;
  .gateitem {
    margin-top: 17px;
    width: 100%;
    // height: 100px;
    border: 1px solid #1a3a6c;
    .gatetop {
      height: 35px;
      line-height: 35px;
      background: #0f3164;
      .name {
        font-size: 15px;
        color: #fff;
        float: left;
        margin-left: 17px;
      }
      .time {
        color: #fff;
        font-size: 14px;
        float: right;
        margin-right: 10px;
      }
      .desc {
        font-size: 14px;
        color: #00deff;
        float: right;
        margin-right: 17px;
      }
    }
    .gateicons {
      margin-top: 6px;
      .gateicon {
        margin-left: 17px;
        height: 55px;
        position: relative;
        margin-top: 5px;
        // margin-bottom: 5px;
        text-align: center;
        width: 22px;
        height: 38px;
        img {
          width: 22px;
          height: 38px;
        }
        span {
          color: #fff;
          font-size: 14px;
          display: block;
        }
      }
    }
  }
}
.meiyu /deep/ .el-table tr {
  // text-align: center;
  color: #fff;
  background: #060a22;
}
.meiyu /deep/ .el-table tr.el-table__row--striped td {
  background: #061737;
}
.meiyu /deep/ .content .el-table .warning-row td {
  background: #b7b71f !important;
}
.meiyu /deep/ .content .el-table .success-row {
  background: #dc3217;
}
.meiyu /deep/ .el-table td {
  // text-align: center;
  padding: 5px 0;
  border: none;
}
.meiyu /deep/ .el-table th.is-leaf {
  border: none;
}
.meiyu /deep/ .el-table th {
  // text-align: center;
  color: #00deff;
  background: #060a22;
}
.meiyu /deep/ .el-table__body tr:hover > td {
  background: #072447;
}
.meiyu /deep/ .el-table::before {
  background: #060a22;
}
.meiyu /deep/ *::-webkit-scrollbar {
  width: 0.25rem;
  height: 0.25rem;
  background-color: #072351;
}
.meiyu /deep/ *::-webkit-scrollbar-track {
  border-radius: 0.1rem;
  background-color: #06214e;
}
.meiyu /deep/ *::-webkit-scrollbar-thumb {
  /*width: 0.1rem;
     */
  height: 0.2rem;
  border-radius: 0.1rem;
  background-color: #0c3974;
}
.meiyu /deep/ .el-table__header {
  table-layout: auto;
  border-collapse: separate;
}
.meiyu /deep/ .el-table__body-wrapper,
.meiyu /deep/ .is-scrolling-none,
.el-table {
  background: #060a22;
}
</style>
